import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_flex _jc-sb _ai-c _gap-1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_heading = _resolveComponent("base-heading")
  const _component_base_button = _resolveComponent("base-button")
  const _component_follow_project_button = _resolveComponent("follow-project-button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_base_heading, {
        tag: "h3",
        class: "gfu-hd--h3"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString($options.headingText), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      _createElementVNode("div", null, _toDisplayString($options.descriptionText), 1 /* TEXT */)
    ]),
    ($options.isOpenForOrders)
      ? (_openBlock(), _createBlock(_component_base_button, {
          key: 0,
          class: "_shrink-0",
          tag: "a",
          href: $options.backProjectUrl,
          theme: "accent",
          onClick: $options.sendAnalytics,
          "data-qa": "comment-section:BackNow"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.Resources.Comments.BackNowButton), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["href", "onClick"]))
      : (_openBlock(), _createBlock(_component_follow_project_button, {
          key: 1,
          "project-id": $options.projectId,
          section: "comment-restricion",
          "project-name": $options.projectName
        }, {
          default: _withCtx(({ onSubscribe }) => [
            _createVNode(_component_base_button, {
              class: "_shrink-0",
              theme: "accent",
              onClick: onSubscribe,
              "data-qa": "comment-section:Follow"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.Resources.ProjectHome.FollowProjectButton), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["project-id", "project-name"]))
  ]))
}